import { useEffect } from 'react';
import usePermissionStore from '../../hooks/store/usePermissionStore';
import useSubscriptionStore from '../../hooks/store/useSubscriptionStore';

export const PermissionInitializer: React.FC = () => {
  const { fetchUserPermissions, clearPermissions } = usePermissionStore();
  const { fetchCurrentSubscription, clearSubscription } = useSubscriptionStore();

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    const token = localStorage.getItem('token');

    if (userId && token) {
      const hasCachedPermissions = Boolean(
        usePermissionStore.getState().userPermissions
      );
      fetchUserPermissions({ silent: hasCachedPermissions });

      const hasCachedSubscription = Boolean(
        useSubscriptionStore.getState().currentSubscription
      );
      fetchCurrentSubscription({ silent: hasCachedSubscription });
    } else {
      clearPermissions();
      clearSubscription();
    }
  }, [fetchUserPermissions, clearPermissions, fetchCurrentSubscription, clearSubscription]);

  // listen logout event
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if ((e.key === 'user_id' || e.key === 'token') && !e.newValue) {
        clearPermissions();
        clearSubscription();
      }
      // listen user_id or token set (login)
      if ((e.key === 'user_id' || e.key === 'token') && e.newValue) {
        const userId = localStorage.getItem('user_id');
        const token = localStorage.getItem('token');
        if (userId && token) {
          const hasCachedPermissions = Boolean(
            usePermissionStore.getState().userPermissions
          );
          fetchUserPermissions({ silent: hasCachedPermissions });

          const hasCachedSubscription = Boolean(
            useSubscriptionStore.getState().currentSubscription
          );
          fetchCurrentSubscription({ silent: hasCachedSubscription });
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [clearPermissions, fetchUserPermissions, clearSubscription, fetchCurrentSubscription]);

  return null;
};

export default PermissionInitializer;

